import dynamic from "next/dynamic";

export const SectorHexagons = dynamic(() => import("./component"));
